import React from 'react';

import { ApolloProvider } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { client } from './backend';
import { AuthProvider } from './contexts/AuthContext';
import { ParentStyleCriteriaProvider } from './contexts/ParentStyleContext';
import { ProfileCriteriaProvider } from './contexts/ProfileImgContext';
import { SubNavCriteriaProvider } from './contexts/SubNavContext';
import theme from './theme';

const AppProviders = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <ApolloProvider client={client}>
        <AuthProvider>
          <ProfileCriteriaProvider>
            <SubNavCriteriaProvider>
              <ParentStyleCriteriaProvider>
                {children}
              </ParentStyleCriteriaProvider>
            </SubNavCriteriaProvider>
          </ProfileCriteriaProvider>
        </AuthProvider>
      </ApolloProvider>
    </LocalizationProvider>
  </ThemeProvider>
);

export default AppProviders;
